<template>
    <div>
        <vSelect :options="deviceTypeOptions" :disabled="disabled" v-model="infoId" :reduce="label => label.code" label="label"/>
    </div>
</template>

<script>
import device from '@/store/displays/device'
import vSelect from 'vue-select'
//import Vue from 'vue'
import 'vue-select/dist/vue-select.css';


export default {
    name: "DeviceTypeSelect",
    components: {
        vSelect
    },
    data() {
        return {
            infoId2: this.infopointId,
        } 
    },
    props: {
        value: String,
        disabled: Boolean
    },
    computed: {
        deviceTypeOptions: function() {
            var list = [];
            for (var a of this.$store.state.device.deviceTypeList) {
                list.push({code: a.value, label: a.text})
            }
            return list;
        },
        infoId: {
            get: function() { return this.value },
            set: function( newValue ) { 
                this.$emit('input' , newValue )}
        }
    },
    created() {
        if (!this.$store.state.device) {
            this.$store.registerModule("device" , device);
        }
    },
    mounted() {
        this.$store.dispatch('device/getDeviceTypeList');
    }
}
</script>